<template>
  <main-layout
    class="quality"
    page-title="质量快检"
    @listen-back="goBack"
    customBack
  >
    <div slot="main-content" class="main-content">
      <div class="ruralContent" v-if="qualityList.length">
        <div
          class="firstImg"
          @click="goToDetail(item)"
          v-for="item in qualityList"
          :key="item.id"
        >
          <div class="quality-block">
            <img src="@/assets/images/qualityInspection/jian.png" alt="" />
            <span class="quality-name">{{ item.thirdCompany }}</span>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>
        <div>暂无机构</div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
// import { getStorage } from "@/utils/storage";
import { qualityInspection } from "@/api/request/snkd.produce";
import { windowHref } from "@/utils/index";
import { mapState, mapActions } from "vuex";

export default {
  name: "InsuranceList",
  components: { MainLayout },
  data() {
    return {
      qualityList: [],
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  async created() {
    await this.getQualityListServe();
  },
  mounted() {},
  methods: {
    ...mapActions("permission", ["hasPermission"]),

    //跳转
    async goToDetail(info) {
      this.$router.push({
        path: "/quality-result-list",
        query: {
          id: info.id,
          thirdCompany: info.thirdCompany,
        },
      });
    },
    //获取列表数据
    async getQualityListServe() {
      const { respCode, obj } =
        await qualityInspection.getQualityCompanyListServe({
          companyId: this.companyId,
        });
      if (respCode === 0) {
        this.qualityList = obj;
        this.isshow = true;
      }
    },
    // 返回上一级跳转到列表页  判断返回页面
    goBack() {
      // 回到主页
      windowHref("/home/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.no-data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}
.quality {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;

    .ruralContent {
      justify-content: flex-start;
      display: flex;
      flex-wrap: wrap;
      div {
        width: 202px;
        height: 210px;
        border-radius: 15px;
        color: #ffffff;
      }

      .quality-block {
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 0px 3px 10px rgba(85, 84, 127, 0.12);
        text-align: center;
        img {
          margin-top: 45px;
          width: 36px;
          height: 46px;
          z-index: 10;
        }
        span {
          display: block;
        }
      }
      .firstImg {
        margin-left: 30px;
        margin-top: 30px;
        background: url("~@/assets/images/ruralInsurance/firstInsurance.png");
        background-size: cover;
      }
      .secondImg {
        margin-left: 30px;
        margin-top: 30px;
        background: url("~@/assets/images/ruralInsurance/secondInsurance.png");
        background-size: cover;
      }
    }
  }
}
.quality-name {
  display: inline-block;
  margin: 0px 15px;
  font-family: "OPPOSans";
  font-style: normal;
  margin-top: 7px;
  font-size: 16px;
  font-weight: 400;
  text-align: center;

  line-height: 24px;
}
::v-deep .common-page-header .title {
  font-size: 22px !important;
}
</style>
